<div class="playlist-title-container flex" [ngClass]="{ searching: isSearching }">
  <ng-container *ngIf="!isSearching; else searching">
    <span class="" translate>MEDIA.PLAYLISTS.TITLE</span>
    <mat-icon
      *ngIf="playlists.length > 0"
      fontSet="fa"
      fontIcon="fa-search"
      (click)="toggleSearch()"
    ></mat-icon>
  </ng-container>
</div>
<ng-template #searching>
  <rk-search-bar
    (inputted)="search($event)"
    [type]="'playlist'"
    (closed)="toggleSearch()"
    [autoFocus]="true"
  ></rk-search-bar>
</ng-template>
<div *ngIf="playlists.length > 0" class="playlists-content" rkPerfectScrollbar #container>
  <ng-container *ngFor="let playlist of playlists; let first = first">
    <rk-playlist-list-line
      [updating]="(updatingPlaylist$ | async) === playlist.id"
      [playlist]="playlist"
      [disableBar]="first"
      [radioId]="radioId"
    ></rk-playlist-list-line>
  </ng-container>
</div>
<ng-container *ngIf="isSearching && !playlists.length">
  <div class="no-results">
    {{ 'MEDIA.PLAYLISTS.NO_RESULTS' | translate : { search: searchSubject.value } }}
  </div>
</ng-container>
<div class="relative">
  <rk-button
    data-cy="add-playlist-button"
    *ngIf="playlists.length === allPlaylists.length"
    class="add-playlist"
    [faIcon]="'fa-plus-circle'"
    [iconSize]="'12px'"
    [label]="'MEDIA.PLAYLISTS.NEW_PLAYLIST' | translate"
    [btnStyle]="'playlist'"
    [pulse]="pulse"
    (click)="createPlaylist()"
  ></rk-button>
  <rk-animated-arrow
    class="checklist-playlist"
    *ngIf="pulse"
    [description]="'CHECKLIST.ARROW.PLAYLIST_DESCRIPTION' | translate"
  ></rk-animated-arrow>
</div>
